module.exports = __webpack_public_path__ + "static/media/Atharva_Satav.5d6dd53b.jpg";